<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md10 sm11>
          <h3 class="text-center">Diagnostic Kits <small>for professionals</small></h3>
          <v-card flat>
            <v-card-title class="py-1">
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" :disabled="diagnostic_kits.length < 1" :append-icon="filterBy.length > 0 ? 'close' : ''" @click:append="() => (filterBy = '')" single-line dense></v-text-field>
              <v-spacer></v-spacer>
              <v-btn small v-if="canCreate" @click="goTo('/diagnostic_kits/create')" text outlined title="Add New">Add New</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="diagnostic_kits" :headers="headers" :search="filterBy" dense>
                <template v-slot:[`item.name`]="{ item }">
                  <inertia-link :href="'/diagnostic_kits/' + item.id" v-text="item.name"></inertia-link>
                </template>
                <template v-slot:[`item.required`]="{ item }">
                  {{ item.required ? 'Y' : 'N' }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'DiagnosticKitsIndex',
    layout,
    props: [
      'diagnostic_kits', 'canCreate'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Diagnostic Kits',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        headers: [
          {
            text: 'Name', value: 'name'
          },
          {
            text: 'Description', value: 'description'
          },
          {
            text: 'Required', value: 'required', align: 'right'
          },
          {
            text: 'Added by', value: 'user.name'
          }
        ],
        filterBy: '',
      }
    },
  }
</script>
